import React, { useState } from "react";
import Box from "@mui/system/Box";
import Sidebar from "layout/Sidebar/Sidebar";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { CircularProgress, Grid, Typography } from "@mui/material";
import {
  CategoryCommon,
  FilterCommon,
  SearchBarCommon,
  SortDataCommon,
  UserProfile,
} from "components";
import { useLocation, useNavigate } from "react-router-dom";
import FooterData from "../../modules/Footer/components/FooterData/FooterData";
import { useAuth } from "context/authContext";

type Props = {
  children: React.ReactNode;
  fullWidth?: boolean;
};

const AppLayout = (props: Props) => {
  const { isLoggedIn, } = useAuth();

  const { children, fullWidth } = props || {};

  const location = useLocation();
  const navigate = useNavigate();
  const isMyLearningPath =
    location.pathname === "/my-learning" ||
    location.pathname === "/learning-log";
  const isLearningLogoPath = location.pathname === "/learning-log";

  const [isSideBarOpen, setSideBarOpen] = React.useState(false);


  const handleSideBarToggle = () => setSideBarOpen(!isSideBarOpen);

  const [activeDropdown, setActiveDropdown] = React.useState<number | null>(
    null
  );

  const handleDropdownToggle = (dropdownIndex: number) => {
    setActiveDropdown(activeDropdown === dropdownIndex ? null : dropdownIndex);
  };

  const handleHome = () => {
    navigate("/");
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh" // Ensures the full viewport height
    >

      <Grid
        bgcolor={"#233F91"}
        p={{ xs: "6.65px", md: 2 }}
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
        }}
      >



        {isLoggedIn && (

          <Box sx={{
            color: "#fff", display: { md: "none", xs: "block" },
            position: "absolute", top: "10px", left: "10px",
            zIndex: 1200
          }}>
            <IconButton
              color="inherit"
              aria-label="open sidebar"
              onClick={handleSideBarToggle}
            >
              <MenuIcon sx={{ width: "29.25px", height: "29.25px" }} />
            </IconButton>
          </Box>

        )}
        <Grid
          display={{ xs: "none", md: "flex" }}
          gap={2}
          zIndex={1}
          alignItems={"center"}
          ml={{ xs: "10px", md: "10px" }}
        >
          <Box
            component="img"
            src="/assets/icons/moblogoWhite.svg"
            alt="logo"
            sx={{
              width: { xs: "70px", md: "112px" },
              height: { xs: "34.17px", md: "35.78px" },
              objectFit: "contain",
              imageRendering: "crisp-edges",
              pl: { xs: "20px", md: "0px" },
              cursor: "pointer",
            }}
            onClick={handleHome}
          ></Box>
          <SearchBarCommon />

        </Grid>


        <Grid display={"flex"} width={"100%"} flexDirection={"column"} justifyContent={"space-between"} gap={0}>
          <Box display={"flex"} justifyContent={'center'} width={"100%"}>
            <UserProfile />
          </Box>



          <Box display={{ xs: "flex", md: "none" }} mt={2} flexDirection={"column"} gap={1} justifyContent={"start"} alignItems={"start"}>


            <Typography fontWeight={400} fontSize={17} color={"#EDEDED"}
            >
              Become a Content Creator
            </Typography>
            <SearchBarCommon />
          </Box>

        </Grid>
      </Grid>


      <Box>
        <Box display="flex" position={"relative"} pt={{ xs: 5, md: 8 }}>
          <Box
            component="nav"
            sx={{
              width: {
                md: 196,
              },
              flexShrink: { sm: 0 },
              zIndex: 0,
              minHeight: "100vh",
            }}
          >
            <Sidebar open={isSideBarOpen} onClose={handleSideBarToggle} />
          </Box>

          <Box
            width={{
              xs: "100%", // Full width on extra small screens
              md: "calc(100% - 196px)", // Apply 196px reduction on medium and larger screens
            }}
          >
            {children}
          </Box>
          {/* <Box width={fullWidth ? "100%" : "calc(100% - 196px)"}>
            {children}
          </Box> */}
        </Box>

        {/* Footer */}
        <Box
          component="footer"
          sx={{
            backgroundColor: "#233F91",
            color: "#fff",
            py: 2,
            textAlign: "center",
          }}
        >
          <FooterData />
        </Box>
      </Box>
    </Box >
  );
};

export default AppLayout;